import {
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_CATEGORIES_SUCCESS: {
      return {
        ...state,
        categories: action.payload.categories,
      }
    }

    case GET_CATEGORIES_FAILURE: {
      return {
        ...state,
        getCategoriesError: action.payload.error,
      }
    }

    default:
      return state
  }
}
